import {
  Verification,
  type EulaProfileFormValues,
} from '@/features/user-verification';
import { useVerificationInfo } from '@/features/user-verification/api/queries/useVerificationInfo';
import { queryClient } from '@/shared/api/queryClient';
import { useModalStore } from '@/shared/lib';
import { cn } from '@/shared/utils';
import { useMemo } from 'react';

export function useVerificationModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const { userVerificationInfo, isVerificationInfoLoading } =
    useVerificationInfo();

  const activeStepId = useMemo(() => {
    return userVerificationInfo?.stepId || null;
  }, [userVerificationInfo?.stepId, queryClient, isVerificationInfoLoading]);

  const openVerificationModal = (initialValues?: EulaProfileFormValues) => {
    showDialogComponent({
      component: (
        <Verification
          initialValues={initialValues}
          goBack={closeDialog}
          onClose={closeDialog}
        />
      ),
      className: cn(activeStepId === 'sumsub' ? 'w-full sm:max-w-[64rem]' : ''),
    });
  };

  return { openVerificationModal };
}
